"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledActionDialogContent = exports.StyledActionDialogContainer = exports.StyledActionDialog = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledActionDialog = (0, styled_components_1.default)(ui_components_1.Dialog) `
  .MuiDialog-paper {
    min-height: 90vh;
    max-height: 90vh;
    min-width: 45vw;
  }

  .MuiDialogContent-root {
    &.alert-dialog-content {
      padding-left: 0;
      padding-right: 0;
      display: flex;
    }
  }

  .MuiDialogActions-root {
    gap: ${({ theme }) => theme.spacing(1)};
  }

  .MuiDialogActions-root .MuiButton-root:last-child {
    order: 1;
    margin-left: auto;
    margin-right: ${({ theme }) => theme.spacing(1.5)};
  }

  .MuiDialogActions-root .Mui-disabled {
    color: ${({ theme }) => theme.palette.action.disabled};
    background-color: ${({ theme }) => theme.palette.action.disabledBackground};
  }
`;
exports.StyledActionDialogContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;
exports.StyledActionDialogContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(3)};
  overflow-y: auto;
  flex: 1;
`;
